// page Help Center

import "./Resources.css"

import React from 'react'
const Helpcenter = () => {
  return (
    <>
    {/* //top div */}

    <div style={{ width: "100%", backgroundColor: 'rgb(23,76,67)', height:"220px",textAlign:"center",margin:"auto",padding:"30px"} }>
        <br/>
        <br/>
   <h1 style={{color:"white",fontSize:"30px",fontWeight:"bold"}}><b>Help Center</b></h1> 
      </div>
<br/>
<br/>


      {/* //bottom div */}

      <div  id="help" style={{width:"70%",margin:"auto"}}>
        <h5><a href="https://www.loom.com/share/b83fff074096407e9f4c1c7d64918e90" target="_blank" style={{textDecoration: 'none',color:"black"}}>Lately How To: Understand your A.I.-generated results page</a></h5>
        <h5><a href="https://www.loom.com/share/6b302464fd51448f857d8a2ac27f24b4" target="_blank" style={{textDecoration: 'none',color:"black"}}>Lately How To: View your A.I.-generated post history</a></h5>
        <h5 ><a href="https://www.loom.com/share/e7e437d246204884ab86e9f6e6e40e31" target="_blank" style={{textDecoration: 'none',color:"black"}}>Lately How To: Reset your password</a></h5>
        <h5 ><a href="https://www.loom.com/share/0952f0211fed475083e0e70adb4fff95" target="_blank" style={{textDecoration: 'none',color:"black"}}>Lately How To: Understand the A.I.-powered Post Success Indicator</a></h5>
        <h5 ><a href="https://www.loom.com/share/91ae16a4cd1549afacaa932e8b5bed35" target="_blank" style={{textDecoration: 'none',color:"black"}}>Lately How To: Add emojis to your A.I.-generated posts</a></h5>
        <h5 ><a href="https://www.loom.com/share/e4cf1af2eb0840579c55e63b21f52ecc" target="_blank" style={{textDecoration: 'none',color:"black"}}>Lately How To: Attach images to your A.I.-generated posts</a></h5>
        <h5 >Lately How To: Add suggested hashtags to your A.I.-generated posts</h5>
        <h5 >Lately How To: Change the default length for your A.I.-generated posts</h5>
        <h5 >Lately How To: View A.I.-generated posts for different channels</h5>
        <h5 >Lately How To: Send your A.I.-generated posts to HubSpot</h5>
        <h5 >Lately How To: Reconnect your accounts</h5>
        <h5 >Lately How To: View, delete and regenerate your previous content sessions</h5>
        <h5 >Lately How To: Access your previous sessions</h5>
        <h5 >Lately How To: Add keywords and hashtags to your account to feed Lately’s A.I.</h5>
        <h5 >Lately How To: Edit your A.I.-generated video clips</h5>
        <h5 >Lately How To: Add a link to A.I.-generated video posts</h5>
        <h5 >Lately How To: Upload a video to generate video posts</h5>
        <h5 >Lately How To: Create A.I.-generated text posts</h5>
        <h5 >Lately How To: Choose the type of content you want to generate from</h5>
        <h5 >Lately How To: Connect your social media publisher</h5>
      </div>
    </>
  )
}

export default Helpcenter